export { PopoverDirective } from './popover.directive';
export { PopoverModule } from './popover.module';
export { PopoverConfig } from './popover.config';
export { PopoverContainerComponent } from './popover-container.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/popover/index.js
// module id = 878
// module chunks = 103